import { BasePage } from '@/components/ui/base-page'

export function SprinklePage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add SprinklePage specific content here */}
    </BasePage>
  )
}